import {Button, Modal} from "antd";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {logoutReset} from "../../react-query-hooks/logout-dispatch";

const StyledModal = styled(Modal)`
  .ant-modal-footer {
    border-top: none;
    padding: 16px 24px;
  }
  .ant-modal-footer .ant-btn {
    padding: 16px 24px;
    height: auto;
  }
`;

interface ICreateCoachAccountModalProps {
  visible: boolean;
  onCancel: () => void;
}

const CreateCoachAccountModal: React.FC<ICreateCoachAccountModalProps> = ({
  visible,
  onCancel,
}) => {
  const navigate = useNavigate();

  const handleCreateCoachAccount = () => {
    logoutReset();
    navigate("/auth/register");
  };

  return (
    <StyledModal
      title="Create your coach account"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="create" type="primary" onClick={handleCreateCoachAccount}>
          Create an account
        </Button>,
      ]}
      centered
      closable
      bodyStyle={{padding: "24px"}}
    >
      <p>To switch to the coach dashboard, you must first set up your coach account.</p>
    </StyledModal>
  );
};

export {CreateCoachAccountModal};
